import React from 'react';
import { Link } from 'react-router-dom';
import { secondsToHoursAndMinutes } from '../../hooks/helpers';
import { inIframe } from '../../utils';
import { useTranslation } from 'react-i18next';

export const PopularCourse = (props) => {
  const { t } = useTranslation('library');

  return (
    <>
      {props.mostPopularCourseDataLoaded ? (
        props.mostPopularCourseData ? (
          <div className="div-block-494">
            <div className="skm b">{t('Top Content')}</div>
            <div className="div-block-400">
              <Link
                className="link-block-27 w-inline-block"
                to={`/courses/${props?.mostPopularCourseData?.course_id}`}
              >
                <div className="text-block-260">
                  {props?.mostPopularCourseData?.name}
                </div>
              </Link>
              <div className="text-block-277">
                {secondsToHoursAndMinutes(
                  props?.mostPopularCourseData?.time_invested
                )}
                <br />
              </div>
            </div>
          </div>
        ) : props.userCoursesLoaded && props.userCourses.length > 0 ? (
          <div className="div-block-494">
            <div className="skm b">{t('Top Content')}</div>
            <div className="div-block-400">
              <Link
                className="link-block-27 w-inline-block"
                to={`/courses/${props?.userCourses[0]?.course_id}`}
              >
                <div className="text-block-260">
                  {props?.userCourses[0]?.course_name}
                </div>
              </Link>
              <div className="text-block-277">
                0:0
                <br />
              </div>
            </div>
          </div>
        ) : (
          props.userCoursesLoaded && (
            <Link to="/discover" style={{ textDecoration: 'none' }}>
              <div className="text-block-31">
                {!inIframe()
                  ? t(
                      "Looks like you haven't enrolled in any courses. Start learning today."
                    )
                  : `${props.username} ${t(
                      "hasn't enrolled in any courses yet."
                    )}`}
              </div>
            </Link>
          )
        )
      ) : (
        <div>{t('Loading...')}</div>
      )}
    </>
  );
};
